// Some browser extensions and endpoint-security tools replace window.MutationObserver with a
// broken stub whose `.prototype` isn't a real object. `new MutationObserver()` then throws
// `TypeError: 'prototype' property of function MutationObserver() {...} is not an object`,
// which crashes anything relying on it — e.g. focus-trap inside our modals (SCI-3144). Swap in
// a harmless no-op observer so consumers degrade instead of crashing.
class NoopMutationObserver implements MutationObserver {
  observe(): void {}
  disconnect(): void {}
  takeRecords(): MutationRecord[] {
    return []
  }
}

const ensureSafeMutationObserver = (): void => {
  if (typeof window.MutationObserver !== 'function') return

  try {
    new window.MutationObserver(() => {}).disconnect()
  } catch {
    window.MutationObserver = NoopMutationObserver
  }
}

export default ensureSafeMutationObserver
